module.exports = __webpack_public_path__ + "static/media/3.22.c0441dc3.png";